import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Rating,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// import React from 'react';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const TaxZeroneVsTax2Efile = () => {
  // const containerRef = useRef(null);

  // const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // const [removelistener, setRemovelistener] = useState(true);
  // const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  // const images = [
  //   '/assets/images/2290-steps-img.webp',
  //   '/assets/images/easy-steps-img.webp',
  //   '/assets/images/941-steps-img.webp',

  // ];
  // const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  // const handleScroll = (event: any) => {
  //   const delta = event.deltaY;
  //   if (delta > 0) {
  //     // Scroll down, show the next imag
  //     if (currentImageIndex < 2) {
  //       setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  //       setRemovelistener(false);
  //     } else {
  //       setRemovelistener(true);
  //     }
  //   } else if (delta < 0) {
  //     // Scroll up, show the previous image
  //     if (currentImageIndex > 0) {
  //       setCurrentImageIndex((prevIndex) =>
  //         prevIndex === 0 ? images.length - 1 : prevIndex - 1
  //       );
  //       setRemovelistener(false);
  //     } else {
  //       setRemovelistener(true);
  //     }
  //   } else {
  //     setRemovelistener(false);
  //   }
  // };
  // function useHorizontalScroll() {
  //   useEffect(() => {
  //     const el = Ref.current;
  //     setTempReturn(tempReturn);
  //     if (el) {
  //       const onWheel = (e: any) => {
  //         if (e.deltaY === 0) return;
  //         e.preventDefault();
  //         el.scrollTo({
  //           behavior: 'smooth',
  //           top: 0,
  //           left: 0,
  //         });
  //       };

  //       el.addEventListener('wheel', onWheel);
  //       if (removelistener === false) {
  //         el.addEventListener('wheel', onWheel);
  //       } else if (removelistener === true) {
  //         el.removeEventListener('wheel', onWheel);
  //       } else {
  //         el.addEventListener('wheel', onWheel);
  //       }
  //       return () => {
  //         el.removeEventListener('wheel', onWheel);
  //       };
  //     }
  //     return () => setTempReturn(false);
  //   }, [removelistener]);
  //   return Ref;
  // }

  // const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="TaxZerone vs Tax2efile: 1099 Filing Software Comparison"
          description="Compare TaxZerone vs Tax2efile for 1099 filing features, pricing, automation, compliance tools, and workflows to choose the right IRS e-file solution."
          keywords=""
          canonical="comparison/taxzerone-vs-tax2efile/"
          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(180deg,rgba(34, 62, 152, 0.32) 0%, rgba(243, 113, 40, 0.08) 66%, rgba(255, 255, 255, 0.34) 97%)
`,
          overflow: 'hidden',
        }}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            alignContent: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              mt: 4,
              mb: 4,
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              TaxZerone <span style={{ color: '#5B4FCB' }}> vs</span> Tax2efile
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 16,
                  md: 18,
                  lg: 18,
                },
                fontWeight: 'normal',
                mb: 4,
                // color: '#5b6472',
                lineHeight: 1.5,
                maxWidth: 900,
                mx: 'auto',
              }}
            >
              Compare TaxZerone and Tax2efile across pricing, supported tax
              forms, automation, compliance features, ease of use, and filing
              experience to determine which platform best fits your filing
              requirements.
            </Typography>

            <Button
              variant="contained"
              className="btn-primary"
              sx={{
                backgroundColor: '#1e2f8f',
                color: '#ffffff',
                fontWeight: 500,
                fontSize: 16,
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                boxShadow: 'none',
                transition: 'all 0.3s ease',
                '&:hover, &:focus, &:active': {
                  backgroundColor: '#16247a',
                  transform: 'scale(1.05)',
                },
              }}
              href="#compare"
            >
              Compare Now
            </Button>
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 20,
                    sm: 28,
                    md: 32,
                    lg: 38,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How do TaxZerone and Tax2efile Compare
              </Typography>
            </Grid>
            <Grid size={{ md: 6, sm: 6, xs: 12 }} textAlign="center">
              <Box>
                <picture>
                  <source srcSet="/assets/images/taxzerone-vs-tax2efile-img.webp" />
                  <source srcSet="/assets/images/taxzerone-vs-tax2efile-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/taxzerone-vs-tax2efile-img.png"
                    loading="lazy"
                    alt="How do TaxZerone and Tax2efile Compare"
                    width={450}
                    height={600}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ md: 6, sm: 6, xs: 12 }}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', sm: 'left', xs: 'center' },
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  color: '#333333',
                  mb: 4,
                  width: '100%',
                }}
              >
                TaxZerone and Tax2efile both support online e-filing for
                information returns, helping businesses, accountants, and tax
                professionals prepare and file forms such as 1099 and 1098 with
                the IRS.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  color: '#333333',
                  mb: 4,
                  width: '100%',
                }}
              >
                <strong style={{ fontWeight: 600 }}>TaxZerone</strong> is a
                better choice for information returns because it supports a wide
                range of commonly filed forms, including 1099, W-2, 1098, 1095,
                5498, 1042-S, and related IRS information-return forms. This
                broader coverage makes it easier for businesses and tax
                professionals to manage multiple information-return filing needs
                from one platform.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  color: '#333333',
                  mb: 4,
                  width: '100%',
                }}
              >
                <strong style={{ fontWeight: 600 }}>Tax2efile</strong> also
                supports information-return filing, including 1099, 1098, and
                ACA-related forms. However, when comparing information-return
                coverage.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#eef9fa',
          my: { xs: 0, md: 8 },
          py: { xs: 4, md: 4 },
        }}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{ px: { xs: 2, md: 4 }, py: { xs: 4, md: 8 } }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              textAlign: 'center',
              fontSize: {
                xs: 20,
                sm: 28,
                md: 32,
                lg: 38,
              },
              lineHeight: 1.3,
              mb: 2,
            }}
          >
            Why Businesses Choose TaxZerone for Comprehensive Filing Needs
          </Typography>

          <Typography
            sx={{
              // lineHeight: 1.8,
              textAlign: 'center',
              color: '#4B5563',
              fontSize: 15.5,
              mb: 4,
            }}
          >
            <strong style={{ fontWeight: 600 }}> TaxZerone</strong> is designed
            for businesses, accountants, and tax professionals managing IRS
            filings at scale, <br /> with broad form support, bulk filing,
            validation tools, and multi-client workflows.
          </Typography>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            spacing={4}
            sx={{ my: { xs: 0, md: -6 } }}
          >
            <Box
              sx={{
                flex: 1,
                maxWidth: { md: 580 },
              }}
            >
              <Box
                component="ol"
                sx={{
                  mb: 2,
                  pl: 3,
                  '& li': {
                    mb: 2.5,
                    pl: 1,
                  },
                  '& li::marker': {
                    fontWeight: 700,
                  },
                }}
              >
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    Centralized IRS Filing
                  </strong>
                  <br />
                  From information returns to business, employment, extension,
                  and other IRS filing categories, TaxZerone helps users manage
                  multiple form types from one platform instead of relying on
                  separate tools for each filing need.
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    Automation for High-Volume Workflows
                  </strong>
                  <br />
                  Bulk uploads, supported file imports, automated checks, and
                  reusable workflows help reduce manual entry and speed up
                  filing preparation, especially for teams processing large
                  batches of returns.
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    Compliance and Client Management Support
                  </strong>
                  <br />
                  With tools for W-9 collection, TIN Matching, validation
                  checks, filing history, user access, and multi-client record
                  management, TaxZerone supports a more organized filing process
                  from data collection through submission.
                </li>
              </Box>
            </Box>

            <Box
              sx={{
                position: 'relative',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: { xs: 280, sm: 340, md: 480 },
                mx: 'auto',
                my: { xs: 0, md: 4 },

                px: { xs: 2, sm: 0 },
              }}
            >
              <Box
                component="img"
                src="/assets/images/why-compare-form-941-e-file-software-img.webp"
                alt="Why Businesses Choose TaxZerone for Comprehensive Filing Needs"
                sx={{
                  width: '80%',
                  height: 'auto',
                  display: 'block',
                  position: 'relative',
                  zIndex: 1,
                }}
              />

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '5%', sm: '12%', md: '10%' },
                  left: { xs: '-5%', sm: '-12%', md: '-1%' },
                  bgcolor: '#FBE4E0',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Automation
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '38%', sm: '40%', md: '42%' },
                  right: { xs: '-8%', sm: '-20%', md: '-8%' },
                  bgcolor: '#F7D9CE',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Client Management
                <br /> Support
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '58%', sm: '54%', md: '50%' },
                  left: { xs: '-6%', sm: '-8%', md: '2%' },
                  bgcolor: '#E3DEF7',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Dedicated U.S <br /> based support
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '5%', sm: '10%', md: '15%' },
                  left: { xs: '0%', sm: '5%', md: '22%' }, // Changed left to right offset on mobile for balanced visual alignment
                  bgcolor: '#F6D9E8',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                State filing
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 20, sm: 28, md: 32, lg: 38 },
                  lineHeight: 1.3,
                  mb: 2,
                  textAlign: 'center',
                  scrollMarginTop: 88,
                }}
                id="compare"
              >
                TaxZerone vs Tax2efile: Comparison
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: 16, sm: 18, md: 18, lg: 20, xl: 22 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 4,
                  textAlign: 'center',
                }}
              >
                TaxZerone offers broad IRS e-filing across multiple tax form
                categories with volume-based pricing, while Tax2efile supports
                information returns, excise, extension, individual, and
                nonprofit filings with tiered pricing.
              </Typography>

              {/* Pricing & Form Support */}
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Pricing & Form Support
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Flexible pricing with support for a wide range of tax forms and
                filing needs.
              </Typography>
              <TableContainer
                sx={{
                  overflowX: { xs: 'auto', md: 'unset' },
                  background: '#ffffff',
                  mx: 'auto',
                  width: '100%',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Pricing & Forms
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Tax2efile
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>
                              Pay-per-form from{' '}
                              <strong style={{ fontWeight: 600 }}>$2.49</strong>
                              , as low as{' '}
                              <strong style={{ fontWeight: 600 }}>
                                $0.59/
                              </strong>
                              form.
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Pricing Model
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          {' '}
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box>
                              From{' '}
                              <strong style={{ fontWeight: 600 }}>
                                $3.25/form
                              </strong>
                              , low as{' '}
                              <strong style={{ fontWeight: 600 }}>
                                $1.99/form
                              </strong>{' '}
                              for 1,001+ forms.
                            </Box>{' '}
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>
                              Supports{' '}
                              <strong style={{ fontWeight: 600 }}>
                                1099, W-2, W-2G, 1098, 1095, 5498, and 1042-S.
                              </strong>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Supported Returns
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box>
                              Supports key{' '}
                              <strong style={{ fontWeight: 600 }}>
                                1099, 1098, ACA, and other information returns.
                              </strong>
                            </Box>{' '}
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              {/* Data Intake & Vendor Onboarding */}
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Data Intake & Vendor Onboarding
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Easily collect, import, and organize vendor information for
                accurate and efficient filing.
              </Typography>

              <TableContainer
                sx={{
                  overflowX: { xs: 'auto', md: 'unset' },
                  background: '#ffffff',
                  mx: 'auto',
                  width: '100%',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Data Intake
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Tax2efile
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          W-9 Collection
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>Formatted Excel and CSV with API imports.</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Imports
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box>Bulk spreadsheet uploads.</Box>{' '}
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>
                              QuickBooks Online, Xero, and other supported
                              integrations.{' '}
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Integrations
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box>
                              QuickBooks, spreadsheet, and API connectivity.
                            </Box>{' '}
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              {/* Data Validation & Verification */}
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Data Validation & Verification
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Validate filer and recipient information to check for errors
                before filing. TaxZerone Data Validation Tax2efile
              </Typography>
              <TableContainer
                sx={{
                  overflowX: { xs: 'auto', md: 'unset' },
                  background: '#ffffff',
                  mx: 'auto',
                  width: '100%',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Data Validation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Tax2efile
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;
                            <Box>
                              Real-time TIN Matching —{' '}
                              <strong style={{ fontWeight: 600 }}>
                                $0.99/form
                              </strong>
                              .
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          TIN Matching
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          TIN Check —{' '}
                          <strong style={{ fontWeight: 600 }}>
                            $1.00/form
                          </strong>
                          .&nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;
                            <Box>
                              Checks for missing or invalid data before
                              submission.
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Validation
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box sx={{ display: 'flex' }}>
                            <Box>
                              {' '}
                              Review and error-checking before submission.
                            </Box>{' '}
                            &nbsp;
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          USPS Address Verification
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              {/* State Filing & Post-Filing Management */}
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                State Filing & Post-Filing Management
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Handle state filing, corrections, and post-filing updates.
                TaxZerone State Filing & Corrections Tax2efile
              </Typography>
              <TableContainer
                sx={{
                  overflowX: { xs: 'auto', md: 'unset' },
                  background: '#ffffff',
                  mx: 'auto',
                  width: '100%',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          State Filing & Corrections
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Tax2efile
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;
                            <Box>
                              {' '}
                              State filing for applicable 1099 and W-2 forms.
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Direct State Filing
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box sx={{ display: 'flex' }}>
                            <Box>
                              State filing for applicable 1099 forms;{' '}
                              <strong style={{ fontWeight: 600 }}>
                                $1.49/form
                              </strong>{' '}
                              additional fee
                            </Box>
                            &nbsp;{' '}
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;
                            <Box>
                              {' '}
                              Supports CFSF for eligible forms and participating
                              states.
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          CFSF (Combined Federal/State Filing)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderBottom: 'none',
                            verticalAlign: 'center',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            <Box>Supports CFSF for participating states.</Box>
                            &nbsp;{' '}
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            // borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;
                            <Box>
                              {' '}
                              Free retransmissions for IRS-rejected returns.
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Rejections
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            <Box>
                              Rejected filings can be corrected and resubmitted
                            </Box>
                            &nbsp;{' '}
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp; <Box> 1099, W-2, and ACA corrections.</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Corrections
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            {' '}
                            <Box> 1099, 1098, and ACA corrections. </Box>
                            &nbsp;
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              {/* Recipient Copy Distribution */}
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Recipient Copy Distribution
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Deliver recipient copies securely and conveniently.{' '}
              </Typography>
              <TableContainer
                sx={{
                  overflowX: { xs: 'auto', md: 'unset' },
                  background: '#ffffff',
                  mx: 'auto',
                  width: '100%',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Recipient delivery
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Tax2efile
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;{' '}
                            <Box>
                              {' '}
                              <strong style={{ fontWeight: 600 }}>
                                {' '}
                                $0.50/form
                              </strong>{' '}
                              via ZeroneVault
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Electronic Delivery
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                          }}
                        >
                          <Box
                            sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          >
                            {' '}
                            <Box>
                              {' '}
                              <strong style={{ fontWeight: 600 }}>
                                {' '}
                                $0.20/email
                              </strong>{' '}
                              for 1099/1098 delivery.{' '}
                            </Box>
                            &nbsp;
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;{' '}
                            <Box>
                              {' '}
                              <strong style={{ fontWeight: 600 }}>
                                {' '}
                                $1.75/ form
                              </strong>{' '}
                              via USPS.
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Print & Postal Mail
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            {' '}
                            <Box>
                              {' '}
                              <strong style={{ fontWeight: 600 }}>
                                {' '}
                                $1.60/form
                              </strong>{' '}
                              for 1–500 forms; up to{' '}
                              <strong style={{ fontWeight: 600 }}>
                                {' '}
                                $2.50/form
                              </strong>{' '}
                              at higher volumes
                            </Box>
                            &nbsp;
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              {/* Filing Flexibility */}
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Filing flexibility
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Schedule filings and use credits for future eligible returns.
              </Typography>
              <TableContainer
                sx={{
                  overflowX: { xs: 'auto', md: 'unset' },
                  background: '#ffffff',
                  mx: 'auto',
                  width: '100%',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Scheduling & Credits
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Tax2efile
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Schedule Filing
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex' }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp; <Box> Prepaid credits never expire.</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Credits
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Box sx={{ display: 'flex' }}>
                            {' '}
                            <Box>
                              {' '}
                              Credits valid for 90 days; unused credits expire.
                            </Box>
                            &nbsp;
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              {/* Security, Team Workflow & Support */}
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Security, Team Workflow & Support
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Secure filing with team collaboration and dedicated support.
              </Typography>

              <TableContainer
                sx={{
                  overflowX: { xs: 'auto', md: 'unset' },
                  background: '#ffffff',
                  mx: 'auto',
                  width: '100%',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Workflow
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Tax2efile
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          Multi-client dashboard for managing client profiles.
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Team Workflow
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Bulk filing workflows for managing multiple vendors or
                          businesses
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 500 }}>
                          24/7 email, live chat and bilingual phone support.
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Support
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Email, bilingual phone, and live chat.
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: '1px solid #ccc !important',
                          }}
                        >
                          SOC 2 Type II and 256-bit encryption.
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Security
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          SSL encryption, secure data transmission, and
                          restricted access controls
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              <Alert
                icon={false}
                sx={{
                  backgroundColor: '#e0f2fe',
                  color: '#334155',
                  fontSize: { xs: '12px', sm: '13px' },
                  lineHeight: 1.5,
                  borderRadius: '12px',
                  padding: '12px 18px',
                  alignItems: 'center',
                  mb: 4,
                  width: '100%',
                  boxShadow: 'none',
                  '& .MuiAlert-icon': { mr: 1.5, padding: 0 },
                  '& .MuiAlert-message': { padding: 0 },
                }}
              >
                <b>Note:</b> This comparison is based on publicly available
                information from the providers' websites. Features, pricing,
                supported forms, and service terms may change. Verify the latest
                details with the provider before making a filing decision.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Box
              sx={{
                pt: 6,
                px: 2,
                maxWidth: '1200px',
                mx: 'auto',
                textAlign: 'center',
              }}
            >
              <Box textAlign="center" sx={{ mb: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,

                    mb: 0,
                  }}
                >
                  What Customers Says About Us
                </Typography>
              </Box>

              <Grid container spacing={0}>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                  }}
                >
                  <Box
                    component="a"
                    href="https://www.trustpilot.com/review/taxzerone.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      justifyContent: 'center',
                      textAlign: 'center',
                      mx: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pr: 1.5,
                        mr: 1.5,
                        borderRight: '1px solid #e5e7eb',
                        height: 48,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 20, sm: 23 },
                          fontWeight: 600,
                          fontFamily: 'Arial, sans-serif',
                          color: '#00b67a',
                          letterSpacing: '-0.5px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Trustpilot
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.7}
                        sx={{
                          height: 20,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          Excellent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          4.4
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.35}
                        sx={{
                          mt: 0.6,
                        }}
                      >
                        {/* Star 1 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 2 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 3 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 4 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 5 - 40% for 4.4 rating */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#d9d9d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {/* Grey Star */}
                          <Typography
                            sx={{
                              position: 'absolute',
                              color: '#ffffff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>

                          {/* Green 40% Star */}
                          <Box
                            sx={{
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              width: '40%',
                              height: '100%',
                              overflow: 'hidden',
                              backgroundColor: '#00b67a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <Typography
                              sx={{
                                width: 20,
                                minWidth: 20,
                                color: '#ffffff',
                                fontSize: 14,
                                lineHeight: 1,
                                textAlign: 'center',
                              }}
                            >
                              ★
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{ border: '1px solid #ccc', borderLeft: 'unset' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/google-reviews.webp" />
                        <source srcSet="/assets/images/google-reviews.png" />
                        <Box
                          component="img"
                          src="/assets/images/google-reviews.png"
                          loading="lazy"
                          alt="Google Review"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    borderLeft: 'unset',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/g2-logo-img.webp" />
                        <source srcSet="/assets/images/g2-logo-img.png" />
                        <Box
                          component="img"
                          src="/assets/images/g2-logo-img.png"
                          loading="lazy"
                          alt="G2 logo"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The W-9 collection and TIN matching help us keep
                        recipient information organized all through TaxZerone
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Rachel Anderson
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#E0F2FE', // Light blue fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The phone support team was really patient and walked me
                        through everything step by step. I had no tax knowledge
                        at all going in. TaxZerone made the whole process feel
                        easy and gave me confidence. 10/10.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Elizabeth Wagner
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#e2dafc',
                        minHeight: 210,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        We handle a high-volume of 1099 filings, and TaxZerone’s
                        bulk upload feature makes the process faster and more
                        convenient. It’s especially helpful during busy filing
                        season.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Jennifer Roberts
                      </Typography>
                    </Paper>
                    {/* 
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Really good chat support experience. I wasn&apos;t sure
                        how to complete a few steps, but Kevin guided me clearly
                        and stayed with me until everything was done. Appreciate
                        the help.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Joseph J Perez
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                        minHeight: 210,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The interface is easy to navigate, and the built-in
                        guidance makes filing much less stressful. TaxZerone
                        helped simplify our compliance process.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Michael Thompson
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#FEF3C7', // Light yellow fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        OMG! I cannot believe how wonderful the live support
                        was. The agent Alexia assisted me with everything I
                        needed and fixed all the issues in the most professional
                        and friendly manner. Amazing customer experience. Thank
                        You!
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Luis Echenique
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          Choose the Right 1099 Filing Solution for Your Business
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Compare pricing, features, automation, and compliance tools to choose
          the platform that best <br />
          fits your filing requirements
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-tax2efile`}
          >
            Get Started with TaxZerone
          </Button>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'center',
              gap: { xs: 1.5, sm: 2, md: 3 },
              width: '100%',
              mt: 2,
              color: '#f3f3f3',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.8,
                whiteSpace: 'nowrap',
              }}
            >
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 16, sm: 18 },
                  fontWeight: 600,
                }}
              >
                ✔
              </Box>
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  fontWeight: 400,
                }}
              >
                No setup fees
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.8,
                whiteSpace: 'nowrap',
              }}
            >
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 16, sm: 18 },
                  fontWeight: 600,
                }}
              >
                ✔
              </Box>
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  fontWeight: 400,
                }}
              >
                No subscriptions
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.8,
                whiteSpace: 'nowrap',
              }}
            >
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 16, sm: 18 },
                  fontWeight: 600,
                }}
              >
                ✔
              </Box>
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  fontWeight: 400,
                }}
              >
                Free Corrections
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.8,
                whiteSpace: 'nowrap',
              }}
            >
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 16, sm: 18 },
                  fontWeight: 600,
                }}
              >
                ✔
              </Box>
              <Box
                component="span"
                sx={{
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  fontWeight: 400,
                }}
              >
                Switch from Tax2efile today
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="comparison-tax2efile-faq"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2, md: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              mt={{ xs: 2, sm: 1 }}
              mb={2}
            >
              <Typography
                variant="h2"
                id="comparison-tax2efile-faq"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Frequently Asked Questions
              </Typography>

              <Box
                component="div"
                sx={{ mb: 0 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Is TaxZerone better than Tax2efile for 1099 filing?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        The better option depends on your filing volume,
                        supported forms, data-import requirements, and preferred
                        filing workflow. TaxZerone offers volume-based pricing,
                        multiple file-import options, scheduled filing, and
                        multi-client management, while Tax2efile offers tiered
                        pricing, bulk spreadsheet uploads, TIN checking, state
                        filing, corrections, and recipient delivery.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Can I switch from Tax2efile to TaxZerone?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        Yes. You can move your filing workflow from Tax2efile to
                        TaxZerone using supported data-import formats such as{' '}
                        <strong style={{ fontWeight: 600 }}>
                          Excel, CSV, EFW2, and FIRE
                        </strong>
                        . The migration process may vary depending on your
                        existing data and filing records. TaxZerone’s{' '}
                        <Link href="/contact-us/" sx={{ color: '#0202ff' }}>
                          support team
                        </Link>{' '}
                        can help guide you through the transition and address
                        any questions along the way.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Can I manage multiple clients with TaxZerone and Tax2efile?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        Yes. Both platforms support managing multiple businesses
                        or clients. TaxZerone provides advanced multi-client
                        management features, including user access controls,
                        centralized records, and filing progress tracking.
                      </Typography>
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        Tax2efile allows users to manage multiple business
                        profiles through its platform.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default TaxZeroneVsTax2Efile;
